/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Buy_As_GiftInputs */

const en_gift_buy_as_gift = /** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy as a Gift`)
};

const es_gift_buy_as_gift = /** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar como Regalo`)
};

const fr_gift_buy_as_gift = /** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter pour offrir`)
};

const de_gift_buy_as_gift = /** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Geschenk kaufen`)
};

const id_gift_buy_as_gift = /** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli sebagai Hadiah`)
};

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const ja_gift_buy_as_gift = en_gift_buy_as_gift;

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const zh_gift_buy_as_gift = en_gift_buy_as_gift;

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const ar_gift_buy_as_gift = en_gift_buy_as_gift;

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const it_gift_buy_as_gift = en_gift_buy_as_gift;

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const ru_gift_buy_as_gift = en_gift_buy_as_gift;

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const pt_gift_buy_as_gift = en_gift_buy_as_gift;

/** @type {(inputs: Gift_Buy_As_GiftInputs) => LocalizedString} */
const ko_gift_buy_as_gift = en_gift_buy_as_gift;

/**
* | output |
* | --- |
* | "Buy as a Gift" |
*
* @param {Gift_Buy_As_GiftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_buy_as_gift = /** @type {((inputs?: Gift_Buy_As_GiftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Buy_As_GiftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_buy_as_gift(inputs)
	if (locale === "es") return es_gift_buy_as_gift(inputs)
	if (locale === "fr") return fr_gift_buy_as_gift(inputs)
	if (locale === "de") return de_gift_buy_as_gift(inputs)
	if (locale === "ja") return ja_gift_buy_as_gift(inputs)
	if (locale === "zh") return zh_gift_buy_as_gift(inputs)
	if (locale === "ar") return ar_gift_buy_as_gift(inputs)
	if (locale === "id") return id_gift_buy_as_gift(inputs)
	if (locale === "it") return it_gift_buy_as_gift(inputs)
	if (locale === "ru") return ru_gift_buy_as_gift(inputs)
	if (locale === "pt") return pt_gift_buy_as_gift(inputs)
	return ko_gift_buy_as_gift(inputs)
});